const baseURL = !document.location.host.includes("getsklad") ? "https://dev.api.getsklad.kz" : "https://api.getsklad.kz";

const apiEndpoints = {
    challenge: `${baseURL}/auth/challenge`,
    confirm: `${baseURL}/auth/confirm`,
    refresh: `${baseURL}/auth/token`,
    logout: `${baseURL}/auth/logout`,

    users: `${baseURL}/api/user/all`,
    owners: `${baseURL}/api/owners`,
    bookings: `${baseURL}/api/bookings`,
    cities: `${baseURL}/api/cities`,
    locations: `${baseURL}/api/locations`,
    boxPrices: `${baseURL}/api/boxprices`
    // Add more endpoints as needed
  };
  
  export default apiEndpoints;
  